import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '@zz2/zz2-ui';

export default class DataActions {
    public static setSelectedUserDivisionIds = createAction('DATA_SET_USER_SELECTED_DIVISION_IDS', withPayloadType<Array<number> | null>())
    public static setSelectedUserDepartmentIds = createAction('DATA_SET_USER_SELECTED_DEPARTMENT_IDS', withPayloadType<Array<number> | null>());
    public static setSelectedUserDateFormat = createAction('DATA_SET_USER_SELECTED_DATE_FORMAT', withPayloadType<string | null>());
    public static reset = createAction('DATA_RESET');
}